import React from 'react'
import { useTranslation } from 'react-i18next'

export const BooleanTextMessage = ({ value, options }) => {
  const { t } = useTranslation()

  const positive = options?.positive || t('yes')

  const negative = options?.negative || t('no')

  return <React.Fragment>{value ? positive : negative}</React.Fragment>
}
